import { Configuration } from "@seriously-rad/seriouslyrad-framework-core/Configuration";
import { EntityCommandTypeEnum } from "@seriously-rad/seriouslyrad-framework-core/EntityCommand";
import { EntityManager } from "@seriously-rad/seriouslyrad-framework-core/EntityManager";
import { JNativeStatic } from "@seriously-rad/seriouslyrad-framework-core/JNative";
import { RadObject } from "@seriously-rad/seriouslyrad-framework-core/RadObject";
import { WindowShim } from "@seriously-rad/seriouslyrad-framework-core/RadWindow";
import { registerCoreAsync, registerPageManagerConfiguration } from "@seriously-rad/seriouslyrad-framework-core/Registration";
import { FullPageLoader } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/FullPageLoader";
import { Page } from "@seriously-rad/seriouslyrad-framework-core/Ui/Pages/Page";
import { EntityCommandOfficerRequestNewFromEmailText } from "./EntityCommands/EntityCommandOfficerRequestNewFromEmailText";
import { EntityCommandTeamMemberRemoveFromTeam } from "./EntityCommands/EntityCommandTeamMemberRemoveFromTeam";
import { EntityCommandUserDelete } from "./EntityCommands/EntityCommandUserDelete";
import { EntityCommandUserSetPassword } from "./EntityCommands/EntityCommandUserSetPassword";
import pageManagerConfiguration from "./Ui/PageManagerConfiguration";

const
    radWindow = WindowShim();

export async function registerAppAsync(configuration: Configuration)
{
    RadObject.registerPropertyDefaultOverride(Page, () => ({
        transitionName: "fadey",
    }));

    radWindow.entityManager = new EntityManager();
    radWindow.fullPageLoader = new FullPageLoader();

    await registerCoreAsync(configuration);

    JNativeStatic.ajaxSetup({
        timeout: null
    });

    radWindow.entityManager.removeCommand({ entityName: "TeamMember", key: "DELETE", type: EntityCommandTypeEnum.entity });
    radWindow.entityManager.registerCommand(new EntityCommandTeamMemberRemoveFromTeam());
    radWindow.entityManager.registerCommand(new EntityCommandUserDelete());
    radWindow.entityManager.registerCommand(new EntityCommandUserSetPassword());
    radWindow.entityManager.registerCommand(new EntityCommandOfficerRequestNewFromEmailText());

    registerPageManagerConfiguration(configuration, pageManagerConfiguration);
}